<template>
    <div ref="container" class="list-footer" @click="onClick">
        <span>{{hint}}</span>
    </div>
</template>
<script>
/**
 * @click 只有在没有加载完的情况下，才允许触发点击事件
 */
export default {
    name: 'ListFooter',
    props: {
        /**
         * 数据数量
         */
        count: {
            type: Number,
        },
        /**
         * 数据是否已经全部加在
         */
        allLoaded: {
            required: true,
            type: Boolean,
        },
        /**
         * 正在请求数据
         */
        requesting: {
            type: Boolean,
            default: false,
        },
        /**
         * 是否检测scroll
         */
        detect: {
            type: Boolean,
            default: true,
        },
        /**
         * 全部加在完成后自定义为本
         */
        loadedText: {
            type: String,
        },
    },
    data() {
        return {
            /**
             * 检测scroll的内容，默认进行检测
             */
            scroll: true,
        };
    },
    computed: {
        hint() {
            if (this.allLoaded) {
                return this.count === 0 ? '暂无数据' : (this.loadedText || '加载完毕，没有更多了~');
            } else {
                if (this.requesting) {
                    return '正在拼命加载';
                } else {
                    if (this.scroll) {
                        return '上滑加载更多';
                    } else {
                        return '点击加载更多';
                    }
                }
            }
        },
    },
    watch: {
        detect(val) {
            this.scroll = val;
        },
    },
    methods: {
        onClick() {
            if (!this.allLoaded) {
                this.$emit('click');
            }
        },
        scrollCallback() {
            if (!this.scroll) {
                // 将不会再有下一个函数被触发
                return;
            }
            // 获得元素
            const $container = this.$refs.container;
            if (!$container) {
                return;
            }

            const rect = $container.getBoundingClientRect();
            // 判断在范围之内，触发更新
            if (rect.top < window.innerHeight * 1.3 && rect.bottom > 0) {
                this.$emit('click');
            }
            return true;
        },
    },
    /**
     * 只有锚定的时候
     */
    mounted() {
        this.scroll = this.detect;
        // 获得元素
        if (this.detect) {
            this.$store.commit('addScrollCallback', this.scrollCallback.bind(this));
        }
    },
    beforeDestroy() {
        // 保证释放掉callback
        this.scroll = false;
    },
};
</script>
<style lang="less">
    @import "../../lib/style/util.less";
    @import "../../lib/style/mixins.less";
    .list-footer {
        text-align: center;
        padding: 15px 0px;
        font-size: 14px;
        color: @second-font-color;
    }
</style>
